export class AuditSignature {
  constructor(public image: string) {

  }
}
